import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';

export const TUTORIALS_VIDEO_URL_MAP: {[key: string]: string} = {
    [EBoardSetting.EMAIL_NOTIFICATIONS]: 'OHs3o7yblWA',
    [EBoardSetting.APP_NOTIFICATIONS]: 'AkahQvpL2zI',
    [EBoardSetting.CARD_PREFIXES]: 'M017Osdjfao',
    [EBoardSetting.CARD_PROPERTIES]: 'y13hPvUAWzc',
    [EBoardSetting.CUSTOM_PROPERTIES]: 'UfWLujpblnE',
    [EBoardSetting.COLOR_LABELS]: 'rj5Tp9ysk1E',
    [EBoardSetting.TAGS]: 'Xsh6jSo7qho',
    [EBoardSetting.ROLES]: 'yMlXKnGLuhc',
    [EBoardSetting.DATES_TIME]: 'xlTGT2rux2M',
    [EBoardSetting.CARD_AGING]: 'CPBP--jIH4M',
    [EBoardSetting.GANTT]: '7HjMtvVWWWA',
    [EBoardSetting.ARCHIVE_UPON_DELETION]: 'ODkGIjNwEb0',
    [EBoardSetting.STATUS_MAPPING]: 'nvoenCmaj3M',
    [EBoardSetting.ESTIMATE]: 'TUrOSTeuQqk',
    [EBoardSetting.LINKS_PREVIEW]: 'wty8FqDYD3o',
    [EBoardSetting.TIME_ZONE]: '1MLClE7dDYI',
    [EBoardSetting.BOARD_EMAIL]: 'CHjcMSA5rac',
    [EBoardSetting.IMPORT]: 'XTMunSnm8T8',
};
